import _ from 'lodash';

import { POST_CLOSING_OPTION_ROUTE_BASE } from 'constants/postClosingOptions';

import {
  httpAccountsApi,
  httpAiApi,
  httpApplyApi,
  httpAusApi,
  httpCrmApi,
  httpDocumentsApi,
  httpFormsApi,
  httpIntegrationsApi,
  httpLoanProcessingApi,
  httpLoansApi,
  httpNotificationsApi,
  httpPricingApi,
  httpSkynetApi,
  httpTelephonyApi,
  httpUnderwritingApi,
} from '../http';

import { AccountingSettingApi } from './accountingSettingApi';
import { ActivitiesApi } from './activitiesApi';
import { AdjustmentCriteriaApi } from './adjustmentCriteriaApi';
import { AdvisorPortalConfigurationApi } from './advisorPortalConfigurationApi';
import { AeBrokerQualityScorecardApi } from './aeBrokerQualityScorecardApi';
import { AeBrokersApi } from './aeBrokersApi';
import { AiAgentsApi } from './aiAgentsApi';
import { AiChatApi } from './aiChatApi';
import { AiChatConfigurationsApi } from './aiChatConfigurationsApi';
import { AiCompositionApi } from './aiCompositionApi';
import { AiConfigApi } from './aiConfigApi';
import { AiDocumentIntakeApi } from './aiDocumentIntakeApi';
import { AiDocumentSplitApi } from './aiDocumentSplitApi';
import { AiExpressionAuthoringApi } from './aiExpressionAuthoringApi';
import { AiModelAssignmentsApi } from './aiModelAssignmentsApi';
import { AiModelsApi } from './aiModelsApi';
import { AiPersonasApi } from './aiPersonasApi';
import { AiProcessesApi } from './aiProcessesApi';
import { AiProcessRunsApi } from './aiProcessRunsApi';
import { AiProcessStepBlobsApi } from './aiProcessStepBlobsApi';
import { AiProcessStepsApi } from './aiProcessStepsApi';
import { AiProcessVersionsApi } from './aiProcessVersionsApi';
import { AiRulesApi } from './aiRulesApi';
import { AiSkillsApi } from './aiSkillsApi';
import { AiStatsApi } from './aiStatsApi';
import { AiStepChecksApi } from './aiStepChecksApi';
import { AiUsageMetricsApi } from './aiUsageMetricsApi';
import { AnalyticsApi } from './analyticsApi';
import { AppKeyApi } from './appKeyApi';
import { ApplicationFeesApiV2 } from './applicaitonFeesApi';
import { ApplicationApi } from './applicationApi';
import { ApplicationAssetApi } from './applicationAssetApi';
import { ApplicationBorrowerApi } from './applicationBorrowerApi';
import { ApplicationChangeApi } from './applicationChangeApi';
import { ApplicationContactsApi } from './applicationContactsApi';
import { ApplicationEditableFieldApi } from './applicationEditableFieldApi';
import { ApplicationFeeEscalationsApi } from './applicationFeeEscalationsApi';
import { ApplicationFeesApi } from './applicationFeesApi';
import { ApplicationImpoundsApi } from './applicationImpoundsApi';
import { ApplicationIncomeApi } from './applicationIncomeApi';
import { ApplicationLeadApi } from './applicationLeadApi';
import { ApplicationLiabilityApi } from './applicationLiabilityApi';
import { ApplicationNonBorrowerEntityApi } from './ApplicationNonBorrowerEntityApi';
import { ApplicationPrepaidsApiV2 } from './applicationPrepaidsApi';
import { ApplicationPricingStatusApi } from './applicationPricingStatusApi';
import { ApplicationPropertyApi } from './applicationPropertyApi';
import { ApplicationResidenceApi } from './applicationResidenceApi';
import { ApplicationSessionApi } from './applicationSessionApi';
import { ApplicationSettingApi } from './applicationSettingApi';
import { ApplicationSubjectPropertyApi } from './applicationSubjectPropertyApi';
import { ApplicationTitleHolderApi } from './applicationTitleHolderApi';
import { ApplicationTrustApi } from './applicationTrustApi';
import { ApplicationV2Api } from './applicationV2Api';
import { AppraisalFeePricingApi } from './appraisalFeePricingApi';
import { AppraisalProductApi } from './appraisalProductApi';
import { AppraisalProductCriteriaApi } from './appraisalProductCriteriaApi';
import { AppraisalSurchargeCriteriaApi } from './appraisalSurchargeCriteriaApi';
import { AppraisalSurchargesApi } from './appraisalSurchargesApi';
import { AsyncFileRequestsApi } from './asyncFileRequestApi';
import { AttendantCompaniesApi } from './attendantCompaniesApi';
import { AuditApi } from './auditApi';
import { AusApi } from './ausApi';
import { AusCredentialValidationApi } from './ausCredentialValidationApi';
import { AusFindingsApi } from './ausFindingsApi';
import { AusSubmitApi } from './ausSubmitApi';
import { AuthApi } from './auth';
import { AuthenticationApi } from './authenticationApi';
import { AuthMethodConfigApi } from './authMethodConfigApi';
import { AutoLockRulesApi } from './autoLockRulesApi';
import { AutomatedActionApi } from './automatedActionApi';
import { AutomatedActionApiV2 } from './automatedActionApiV2';
import { BankrateLeadProviderApi } from './bankrateLeadProviderApi';
import { BrokerActionItemsApi } from './brokerActionItemsApi';
import { BrokerAnnouncementsAdminApi } from './brokerAnnouncementsAdminApi';
import { BrokerAnnouncementsApi } from './brokerAnnouncementsApi';
import { BrokerApi } from './brokerApi';
import { BrokerClientProtectionAdminApi } from './brokerClientProtectionAdminApi';
import { BrokerClientProtectionApi } from './brokerClientProtectionApi';
import { BrokerCompPlanApi } from './brokerCompPlanApi';
import { BrokerPipelineApi } from './brokerPipelineApi';
import { BrokerQualityScorecardLoansApi } from './brokerQualityScorecardLoansApi';
import { BrokerQualityScorecardUnderwritingApi } from './brokerQualityScorecardUnderwritingApi';
import { BusinessDaysApi } from './businessDaysApi';
import { BuyDownsApi } from './buyDownsApi';
import { CalendarEventApi } from './calendarEventApi';
import { CallApi } from './callApi';
import { CampaignApi } from './campaignApi';
import { CapturePolicyApi } from './capturePolicyApi';
import { ChannelApi } from './channelApi';
import { ChannelProgramApi } from './channelProgramApi';
import { ChatEscalationApi } from './chatEscalationApi';
import { ChatsApi } from './chatsApi';
import { ChattelDetailsApi } from './chattelDetailsApi';
import { ChecklistsApi } from './checklistsApi';
import { CicFeeReasonsApi } from './cicFeeReasonsApi';
import { CicFeeReasonsApiV2 } from './cicFeeReasonsApiV2';
import { ClaimsApi } from './claimsApi';
import { ClosingApi } from './closingApi';
import { ClosingDocumentsApi } from './closingDocumentsApi';
import { ClosingInfoApi } from './closingInfoApi';
import { ClosingPortalApi } from './closingPortalApi';
import { CommandCenterLoansApi } from './commandCenterLoansApi';
import { CommandCenterPageConfigApi } from './commandCenterPageConfigApi';
import { CommandCenterPricingApi } from './commandCenterPricingApi';
import { CommandCenterUnderwritingApi } from './commandCenterUnderwritingApi';
import { CompanyApi } from './companyApi';
import { CompanyAudioRecordingApi } from './companyAudioRecordingApi';
import { CompanyCenterApi } from './companyCenterApi';
import { CompanyClaimRestrictionsApi } from './companyClaimRestrictionsApi';
import { CompanyCompensationComplianceApi } from './companyCompensationComplianceApi';
import { CompanyDomainApi } from './companyDomainApi';
import { CompanyEmailDomainApi } from './companyEmailDomainApi';
import { CompanyFormFieldsApi } from './companyFormFieldsApi';
import { CompanyIpWhitelistApi } from './companyIpWhitelistApi';
import { CompanyLicenseStateApi } from './companyLicenseStateApi';
import { CompanyLoanNumberApi } from './companyLoanNumberApi';
import { CompanyPropertiesApi } from './companyPropertiesApi';
import { CompanyRoleRestrictionsApi } from './companyRoleRestrictionsApi';
import { CompanySsoInfoApi } from './companySsoInfoApi';
import { CompanyTemplateApi } from './companyTemplateApi';
import { CompanyVolumeApi } from './companyVolumeApi';
import { ConditionApi } from './conditionApi';
import { ConditionCategoryApi } from './conditionCategoryApi';
import { ConditionConditionSetApi } from './conditionConditionSetApi';
import { ConditionPriorToTypeDefinitionApi } from './conditionPriorToTypeDefinitionApi';
import { ConditionProgramLoanTypeApi } from './conditionProgramLoanTypeApi';
import { ConditionSetApi } from './conditionSetApi';
import { ConstructionApi } from './constructionApi';
import { ContactCustomFieldDefinitionsApi } from './contactCustomFieldDefinitionsApi';
import { ContactsApi } from './contactsApi';
import { ContactsPresentationApi } from './contactsPresentationApi';
import { ContactTaskApi } from './contactTaskApi';
import { ContactTypesApi } from './contactTypesApi';
import { CreditCompaniesApi } from './creditCompaniesApi';
import { CrmContactApi } from './crmContactApi';
import { CrmPipelineApi } from './crmPipelineApi';
import { CrmTagApi } from './crmTagApi';
import { CsvMappingApi } from './csvMappingApi';
import { CsvMappingDefinitionApi } from './csvMappingDefinitionApi';
import { CubeIntegrationApi } from './cubeIntegrationApi';
import { CustomActionApi } from './customActionApi';
import { CustomAdjustmentTypeApi } from './customAdjustmentTypeApi';
import { CustomQuestionsApi } from './customQuestionsApi';
import { CustomRuleApi } from './customRuleApi';
import { CustomRuleCategoryApi } from './customRuleCategoryApi';
import { CustomRuleGroupApi } from './customRuleGroupApi';
import { DataVerifyApi } from './dataVerifyApi';
import { DealApi } from './dealApi';
import { DealerApi } from './dealerApi';
import { DenialReasonsApi } from './denialReasonsApi';
import { DevicesApi } from './devicesApi';
import { DocumentApi } from './documentApi';
import { DocumentAuditEventsApi } from './documentAuditEventsApi';
import { DocumentBundleApi } from './documentBundleApi';
import { DocumentBundlesApi } from './documentBundlesApi';
import { DocumentCategoriesApi } from './documentCategoriesApi';
import { DocumentExpirationDatesApi } from './documentExpirationDatesApi';
import { DocumentExtractionSessionsApi } from './documentExtractionSessionsApi';
import { DocumentFieldTypeApi } from './documentFieldTypeApi';
import { DocumentsApi } from './documentsApi';
import { DocumentTypeAliasesApi } from './documentTypeAliasesApi';
import { DocumentTypeCalculationFieldApi } from './documentTypeCalculationFieldApi';
import { DocumentTypeExpressionDefinitionApi } from './documentTypeExpressionDefinitionApi';
import { DocumentTypeExtractionFieldApi } from './documentTypeExtractionFieldApi';
import { DocumentTypeFieldsMappingApi } from './documentTypeFieldsMappingApi';
import { DocumentTypesApi } from './documentTypesApi';
import { DocumentWorksheetApi } from './documentWorksheetApi';
import { EligibilityCriteriaApi } from './eligibilityCriteriaApi';
import { EmailNotificationApi } from './emailNotificationApi';
import { EmailSignatureApi } from './emailSignatureApi';
import { EmailSignaturePreviewApi } from './emailSignaturePreviewApi';
import { EmailSnippetsApi } from './emailSnippetsApi';
import { EmailTemplateApi } from './emailTemplateApi';
import { EmailTemplateCategoryApi } from './emailTemplateCategoryApi';
import { EmailTemplateProcessingApi } from './emailTemplateProcessingApi';
import { EntityOrderApi } from './entityOrderApi';
import { EscrowCriteriaApi } from './escrowCriteriaApi';
import { ExceptionSubCategoriesApi } from './exceptionSubCategoriesApi';
import { ExpressionDefinitionApi } from './expressionDefinitionApi';
import { ExpressionDefinitionApiV2 } from './expressionDefinitionApiV2';
import { ExternalProgramMappingsApi } from './externalProgramMappingsApi';
import { FeatureTogglesApi } from './featureTogglesApi';
import { FeeProviderCategoryApi } from './feeProviderCategoryApi';
import { FeeProviderCategoryPricingApi } from './feeProviderCategoryPricingApi';
import { FeeProviderPricingApi } from './feeProviderPricingApi';
import { FeeTypeMismoApi } from './feeTypeMismoApi';
import { FeeTypePricingApi } from './feeTypePricingApi';
import { FinancialInfoApi } from './financialInfoApi';
import { FormApi } from './formApi';
import { FormBundleApi } from './formBundleApi';
import { FormBundleCriteriaApi } from './formBundleCriteriaApi';
import { FormBundlesApi } from './formBundlesApi';
import { FormBundleSignatureRequestApi } from './formBundleSignatureRequestApi';
import { FormBundleTestingToolApi } from './formBundleTestingToolApi';
import { FormDeliveryRequestApi } from './formDeliveryRequestsApi';
import { FormsApi } from './formsApi';
import { FormsExpressionDefinitionApi } from './formsExpressionDefinitionApi';
import { FormsTestingToolApi } from './formsTestingToolApi';
import { FreddieConnectionApi } from './freddieConnectionApi';
import { FundingInformationApi } from './fundingInformationApi';
import { GsePricingAnalyticsApi } from './gsePricingAnalyticsApi';
import { GsePricingApi } from './gsePricingApi';
import { GuidelinesApi } from './guidelinesApi';
import { GuidelineSourceExclusionApi } from './guidelineSourceExclusionApi';
import { HalcyonFormCatalogApi } from './halcyonFormCatalogApi';
import { HeaderViewApi } from './headerViewApi';
import { HousingFinanceAgenciesApi } from './housingFinanceAgenciesApi';
import { HttpRequestLogsApi } from './httpRequestLogsApi';
import { HudApi } from './hudApi';
import { ImportMismoApi } from './importMismoApi';
import { ImpoundTypeApiV2 } from './impoundTypeApiV2';
import { IncomeCalculatorApi } from './incomeCalculatorApi';
import { IndexTypeApi } from './indexTypeApi';
import { IntegrationStudioApi } from './integrationStudioApi';
import { InvestorApi } from './investorApi';
import { InvestorFeatureCodesApi } from './investorFeatureCodesApi';
import { InvestorProductPlanIdentifiersApi } from './investorProductPlanIdentifiersApi';
import { KnowledgeItemExclusionApi } from './knowledgeItemExclusionApi';
import { KnowledgeItemsApi } from './knowledgeItemsApi';
import { LeadAssignmentRulesApi } from './leadAssignmentRulesApi';
import { LeadSourceApi } from './leadSourceApi';
import { LeadWorkspaceApi } from './leadWorkspaceApi';
import { LegacySftpConnectorApi } from './legacySftpConnectorApi';
import { LendersMappingsApi } from './LendersMappingsApi';
import { LienPriorityApi } from './lienPriority';
import { LlpaCapCriteriaApi } from './llpaCapCriteriaApi';
import { LlpaTypeApi } from './llpaTypeApi';
import { LoanActionApi } from './loanActionApi';
import { LoanActionApiV2 } from './loanActionApiV2';
import { LoanActivityApi } from './loanActivityApi';
import { LoanApi } from './loanApi';
import { LoanApplicationBorrowersApi } from './loanApplicationBorrowersApi';
import { LoanApplicationCommonInfoApi } from './loanApplicationCommonInfo';
import { LoanApplicationNonBorrowersApi } from './loanApplicationNonBorrowersApi';
import { LoanApplicationRoleAssignmentsApi } from './loanApplicationRoleAssignmentsApi';
import { LoanApplicationsApi } from './loanApplicationsApi';
import { LoanApplicationsProgressApi } from './loanApplicationsProgressApi';
import { LoanApplicationTagsApi } from './loanApplicationTagsApi';
import { LoanApplicationTagsAssignmentsApi } from './loanApplicationTagsAssignmentsApi';
import { LoanAppraisalSurchargesApi } from './loanAppraisalSurchargesApi';
import { LoanChecklistsApi } from './loanChecklistsApi';
import { LoanCicHistoryApi } from './loanCicHistoryApi';
import { LoanConditionApiV2 } from './loanConditionApiV2';
import { LoanConformingLimitsApi } from './loanConformingLimitsApi';
import { LoanConsentsApi } from './loanConsentsApi';
import { LoanContactsApi } from './loanContactsApi';
import { LoanDenialReasonsApi } from './loanDenialReasonsApi';
import { LoanEditorCustomFormsApi } from './loanEditorCustomFormsApi';
import { LoanExceptionsApi } from './loanExceptionsApi';
import { LoanFeeRecommendationsApi } from './loanFeeRecommendationsApi';
import { LoanImportsApi } from './loanImportsApi';
import { LoanKeyDatesApi } from './loanKeyDatesApi';
import { LoanLockDeskSettingsApi } from './loanLockDeskSettingsApi';
import { LoanLodeStarQuestionsApi } from './loanLodeStarQuestionsApi';
import { LoanOfficersManagementApi } from './loanOfficersManagement';
import { LoanOptionApi } from './loanOptionApi';
import { LoanPipelinesApi } from './loanPipelinesApi';
import { LoanProcessingDefinitionsApi } from './loanProcessingDefinitionsApi';
import { LoanPropertyApi } from './loanPropertyApi';
import { LoanRequestsApi } from './loanRequestsApi';
import { LoanRoleApi } from './loanRoleApi';
import { LoanRoleRelationshipsApi } from './loanRoleRelationshipsApi';
import { LoanRolesApi } from './loanRolesApi';
import { LoanSellerAdjustmentsApi } from './loanSellerAdjustmentsApi';
import { LocalizationLanguageApi } from './localizationLanguageApi';
import { LocalizationStringApi } from './localizationStringApi';
import { LocationsApi } from './locationsApi';
import { LockExpiryApi } from './lockExpiryApi';
import { LodeStarFeeTypeApi } from './lodeStarFeeTypeApi';
import { LodeStarFeeTypePricingApi } from './lodeStarFeeTypePricingApi';
import { MarginChangeRequestApi } from './marginChangeRequestApi';
import { MarginConcessionApi } from './marginConcessionApi';
import { MarginCriteriaApi } from './marginCriteriaApi';
import { MarginGuardrailApi } from './marginGuardrailApi';
import { MarginPlanApi } from './marginPlanApi';
import { MarketRatesApi } from './marketRatesApi';
import { MarkToMarketSettingApi } from './markToMarketSettingApi';
import { MiCoveragePercentageCriteriaApi } from './miCoveragePercentageCriteria';
import { MilestoneDefinitionsApi } from './milestoneDefinitionsApi';
import { MIRulesCriteriaApi } from './miRulesCriteriaApi';
import { MobileAppReleaseApi } from './mobileAppReleaseApi';
import { MortgageReportsApi } from './mortgageReportsApi';
import { MsrValueApi } from './msrValueApi';
import { NmlsLicenseApi } from './nmlsLicenseApi';
import { NotificationsApi } from './notificationsApi';
import { OptimalBluePricingApi } from './optimalBluePricingApi';
import { OptimizationStrategyApi } from './optimizationStrategyApi';
import { PhoneNumberApi } from './phoneNumberApi';
import { PipelineStatusApi } from './pipelineStatusApi';
import { PosConfigurationApi } from './posConfigurationApi';
import { PostClosingApi } from './postClosingApi';
import { PostClosingOptionListApi } from './postClosingOptionListApi';
import { PriceSourcesApi } from './priceSourcesApi';
import { PriceSourceUploadsApi } from './priceSourceUploadsApi';
import { PricingCalendarApi } from './pricingCalendarApi';
import { PricingConfigurationApi } from './pricingConfigurationApi';
import { PricingWorkbenchApi } from './pricingWorkbenchApi';
import { ProgramApi } from './programApi';
import { ProgramIdentifiersApi } from './programIdentifiersApi';
import { PropertyEnrichmentApi } from './propertyEnrichmentApi';
import { PushNotificationsApi } from './pushNotificationsApi';
import { PushNotificationsDispatchApi } from './pushNotificationsDispatchApi';
import { RateLockTermsCriteriaApi } from './rateLockTermsCriteriaApi';
import { RealtorsApi } from './realtorsApi';
import { RecordingRequirementsApi } from './recordingRequirementsApi';
import { RolesManagementApi } from './rolesManagementApi';
import { SearchSynonymApi } from './searchSynonymApi';
import { SellerAdjustmentTypeApi } from './sellerAdjustmentTypeApi';
import { ServicelinkFloodApi } from './servicelinkFloodApi';
import { ServicingApi } from './servicingApi';
import { ServicingCompaniesApi } from './servicingCompaniesApi';
import { ShapeLeadProviderApi } from './shapeLeadProviderApi';
import { SlaGroupApi } from './slaGroupsApi';
import { SnapdocsClosingApi } from './snapdocsClosingApi';
import { SnapdocsSubscriptionsApi } from './snapdocsSubscriptionsApi';
import { SpecifiedPoolApi } from './specifiedPoolApi';
import { SsoApi } from './ssoApi';
import { StateSigningRequirementsApi } from './stateSigningRequirementsApi';
import { SubCompaniesApi } from './subCompaniesApi';
import { SubCompanyAgencyApprovalsApi } from './subCompanyAgencyApprovalsApi';
import { SubCompanyAssignedAeApi } from './subCompanyAssignedAeApi';
import { SubCompanyCeilingDerivationApi } from './subCompanyCeilingDerivationApi';
import { SubCompanyChannelsApi } from './subCompanyChannelsApi';
import { SubCompanyChecklistsApi } from './subCompanyChecklistsApi';
import { SubCompanyChecklistsAuthoringApi } from './subCompanyChecklistsAuthoringApi';
import { SubCompanyCompensationPlanApi } from './subCompanyCompensationPlanApi';
import { SubCompanyCreditProviderApi } from './subCompanyCreditProviderApi';
import { SubCompanyLicenseStateApi } from './subCompanyLicenseStateApi';
import { SubCompanyLoanCountApi } from './subCompanyLoanCountApi';
import { SubCompanyOwnerStatusApi } from './subCompanyOwnerStatusApi';
import { SubCompanyPipelineAccessApi } from './subCompanyPipelineAccessApi';
import { SubCompanyPipelineApi } from './subCompanyPipelineApi';
import { SubCompanyTaskApi } from './subCompanyTaskApi';
import { SubmissionReadinessApi } from './submissionReadinessApi';
import { SystemPropertiesApi } from './systemPropertiesApi';
import { TagApi } from './tagApi';
import { TaskApi } from './taskApi';
import { TaskCategoryApi } from './taskCategoryApi';
import { TaskCategoryExclusionApi } from './taskCategoryExclusionApi';
import { TaskSlaGroupApi } from './taskSlaGroupApi';
import { TaskTypeApi } from './taskTypeApi';
import { TaskTypeDynamicFieldApi } from './taskTypeDynamicFieldApi';
import { TaskTypeExclusionApi } from './taskTypeExclusionApi';
import { TelephonyApi } from './telephonyApi';
import { TelnyxPhoneNumberApi } from './telnyxPhoneNumberApi';
import { TexmlApplicationsApi } from './texmlApplicationsApi';
import { TpoCertificationApi } from './tpoCertificationApi';
import { TpoCertificationsApi } from './tpoCertificationsApi';
import { TpoDenialConfigurationApi } from './tpoDenialConfigurationApi';
import { TpoExposedPipelinesValidationApi } from './tpoExposedPipelinesValidationApi';
import { TpoRecapEarningsApi } from './tpoRecapEarningsApi';
import { TpoSignupConfigurationApi } from './tpoSignupConfigurationApi';
import { TradeApi } from './tradeApi';
import { TurnTimeDefinitionApi } from './turnTimeDefinitionApi';
import { UiProgramSettingsApi } from './uiProgramSettingsApi';
import { UnderwriterApi } from './underwriterApi';
import { UnderwritingApi } from './underwritingApi';
import { UnderwritingDocExpirationSettingsApi } from './underwritingDocExpirationSettingsApi';
import { UnderwritingExpressionDefinitionApi } from './underwritingExpressionDefinitionApi';
import { UnderwritingReportApi } from './underwritingReportApi';
import { UnderwritingSettingsApi } from './underwritingSettingsApi';
import { UserApi } from './userApi';
import { UserAudioRecordingApi } from './userAudioRecordingApi';
import { UserLeadAssignmentRule } from './userLeadAssignmentRule';
import { UserLicenseStateApi } from './userLicenseStateApi';
import { UserPropertiesManagementApi } from './userPropertiesManagementApi';
import { UsersManagementApi } from './usersManagement';
import { VestingTypeApi } from './vestingTypeApi';
import { WarehouseBankApi } from './warehouseBankApi';
import { WarehouseBankLineApi } from './warehouseBankLineApi';
import { WarehouseLineAllocationApi } from './warehouseLineAllocationApi';
import { WebhooksApi } from './webhooksApi';
import { WhitelistApi } from './whitelistApi';
import { WireInstructionConfirmationApi } from './wireInstructionConfirmationApi';

export const accountingSettingApi = new AccountingSettingApi(httpSkynetApi);

export const activitiesApi = new ActivitiesApi(httpSkynetApi);

export const adjustmentCriteriaApi = new AdjustmentCriteriaApi(httpPricingApi);

export const loanConformingLimitsApi = new LoanConformingLimitsApi(httpPricingApi);

export const gsePricingAnalyticsApi = new GsePricingAnalyticsApi(httpPricingApi);

export const gsePricingApi = new GsePricingApi(httpPricingApi);

export const marginPlanApi = new MarginPlanApi(httpPricingApi);

export const marginCriteriaApi = new MarginCriteriaApi(httpPricingApi);

export const capturePolicyApi = new CapturePolicyApi(httpPricingApi);

export const marginGuardrailApi = new MarginGuardrailApi(httpPricingApi);

export const marginChangeRequestApi = new MarginChangeRequestApi(httpPricingApi);

export const marginConcessionApi = new MarginConcessionApi(httpPricingApi);

export const pricingCalendarApi = new PricingCalendarApi(httpPricingApi);

export const priceSourcesApi = new PriceSourcesApi(httpPricingApi);

export const priceSourceUploadsApi = new PriceSourceUploadsApi(httpPricingApi);

export const freddieConnectionApi = new FreddieConnectionApi(httpPricingApi);

export const aiChatApi = new AiChatApi(httpAiApi);

export const aiDocumentIntakeApi = new AiDocumentIntakeApi(httpAiApi);
export const aiDocumentSplitApi = new AiDocumentSplitApi(httpAiApi);

export const aiExpressionAuthoringApi = new AiExpressionAuthoringApi(httpAiApi);

export const applicationApi = new ApplicationApi(httpSkynetApi);

export const applicationV2Api = new ApplicationV2Api(httpSkynetApi);

export const applicationAssetApi = new ApplicationAssetApi(httpSkynetApi);

export const applicationIncomeApi = new ApplicationIncomeApi(httpSkynetApi);

export const applicationLeadApi = new ApplicationLeadApi(httpSkynetApi);

export const applicationLiabilityApi = new ApplicationLiabilityApi(httpSkynetApi);

export const applicationBorrowerApi = new ApplicationBorrowerApi(httpSkynetApi);

export const applicationChangeApi = new ApplicationChangeApi(httpSkynetApi);

export const applicationEditableFieldApi = new ApplicationEditableFieldApi(httpSkynetApi);

export const applicationFeesApi = new ApplicationFeesApi(httpSkynetApi);

export const applicationFeeEscalationsApi = new ApplicationFeeEscalationsApi(httpSkynetApi);

export const applicationFeesApiV2 = new ApplicationFeesApiV2(httpPricingApi);

export const applicationPrepaidsApiV2 = new ApplicationPrepaidsApiV2(httpSkynetApi);

export const applicationNonBorrowerEntityApi = new ApplicationNonBorrowerEntityApi(httpSkynetApi);

export const applicationPricingStatusApi = new ApplicationPricingStatusApi(httpPricingApi);

export const applicationPropertyApi = new ApplicationPropertyApi(httpSkynetApi);

export const loanPropertyApi = new LoanPropertyApi(httpLoansApi);

export const loanRequestsApi = new LoanRequestsApi(httpLoansApi);

export const stateSigningRequirementsApi = new StateSigningRequirementsApi(httpLoansApi);

export const recordingRequirementsApi = new RecordingRequirementsApi(httpLoansApi);

export const applicationResidenceApi = new ApplicationResidenceApi(httpSkynetApi);

export const applicationSessionApi = new ApplicationSessionApi(httpSkynetApi);

export const applicationSettingApi = new ApplicationSettingApi(httpSkynetApi);

export const applicationSubjectPropertyApi = new ApplicationSubjectPropertyApi(httpSkynetApi);

export const applicationTitleHolderApi = new ApplicationTitleHolderApi(httpSkynetApi);

export const applicationTrustApi = new ApplicationTrustApi(httpSkynetApi);

export const appraisalProductApi = new AppraisalProductApi(httpSkynetApi);

export const appraisalProductCriteriaApi = new AppraisalProductCriteriaApi(httpAusApi);

export const appraisalSurchargeCriteriaApi = new AppraisalSurchargeCriteriaApi(httpAusApi);

export const appraisalFeePricingApi = new AppraisalFeePricingApi(httpPricingApi);

export const appraisalSurchargesApi = new AppraisalSurchargesApi(httpPricingApi);

export const asyncFileRequestsApi = new AsyncFileRequestsApi(httpSkynetApi);

export const attendantCompaniesApi = new AttendantCompaniesApi(httpSkynetApi);

// FH-2520 inline entity audit history — reads the shared Audit.Read endpoints off the
// Skynet.Loans AuditController host (FH-2583) via httpLoansApi, base path api/audit.
export const auditApi = new AuditApi(httpLoansApi, 'api/audit');

export const loanProcessingAuditApi = new AuditApi(httpLoanProcessingApi, 'api/audit');

export const formsAuditApi = new AuditApi(httpFormsApi, 'api/audit');

export const authApi = new AuthApi(httpAccountsApi);

export const authMethodConfigApi = new AuthMethodConfigApi(httpAccountsApi);

export const authenticationObsoleteApi = new AuthenticationApi(httpSkynetApi);

export const automatedActionApiV2 = new AutomatedActionApiV2(httpLoanProcessingApi);

export const autoLockRulesApi = new AutoLockRulesApi(httpLoanProcessingApi);

export const automatedActionApi = new AutomatedActionApi(httpSkynetApi);

export const brokerApi = new BrokerApi(httpSkynetApi);

export const lendersMappingsApi = new LendersMappingsApi(httpPricingApi);

export const externalProgramMappingsApi = new ExternalProgramMappingsApi(httpPricingApi);

export const optimalBluePricingApi = new OptimalBluePricingApi(httpPricingApi);

export const calendarEventApi = new CalendarEventApi(httpSkynetApi);

export const callApi = new CallApi(httpTelephonyApi);

export const channelApi = new ChannelApi(httpPricingApi);

export const channelProgramApi = new ChannelProgramApi(httpPricingApi);

export const chatEscalationApi = new ChatEscalationApi(httpAccountsApi);

export const chatsApi = new ChatsApi(httpNotificationsApi, httpSkynetApi);

export const chattelDetailsApi = new ChattelDetailsApi(httpSkynetApi);

export const checklistsApi = new ChecklistsApi(httpSkynetApi, httpLoansApi);

export const loanChecklistsApi = new LoanChecklistsApi(httpLoansApi);

export const loanCicHistoryApi = new LoanCicHistoryApi(httpSkynetApi);

export const applicationImpoundsApi = new ApplicationImpoundsApi(httpSkynetApi);

export const cicFeeReasonsApi = new CicFeeReasonsApi(httpSkynetApi);
export const cicFeeReasonsApiV2 = new CicFeeReasonsApiV2(httpPricingApi);

export const impoundTypeApiV2 = new ImpoundTypeApiV2(httpPricingApi);

export const investorFeatureCodesApi = new InvestorFeatureCodesApi(httpPricingApi);

export const programIdentifiersApi = new ProgramIdentifiersApi(httpSkynetApi);

export const claimsApi = new ClaimsApi(httpSkynetApi);

export const companyApi = new CompanyApi(httpAccountsApi);

export const companyCenterApi = new CompanyCenterApi(httpApplyApi);

// Skynet.Accounts CompaniesController route — same gateway as the sibling
// company-config clients (claim-restrictions, compensation-compliance).
export const commandCenterPageConfigApi = new CommandCenterPageConfigApi(httpAccountsApi);

// DEV-3636 broker-home real-data clients. Loans-gateway reads (action items,
// lock expiry, activity, funded-unit count), Pricing-gateway market intel (same
// direct base as channelApi), Accounts comp-plan, and the SkynetAPI earnings
// recap (owner-only, legal-gated).
export const brokerActionItemsApi = new BrokerActionItemsApi(httpLoansApi);

export const brokerPipelineApi = new BrokerPipelineApi(httpLoansApi);

// DEV-3782 per-loan submission-readiness check (TPO broker). Loans-gateway read,
// keyed by applicationId; degrades on 403/empty to the neutral state.
export const submissionReadinessApi = new SubmissionReadinessApi(httpLoansApi);

// DEV-3777 file-quality scorecard — two halves merged client-side. The
// Underwriting gateway fills the condition metrics; the Loans gateway fills
// broker-owned time-in-status. Both 404 when the backend feature toggle is off,
// which the slice treats as "not available" so the whole zone stays dark.
export const brokerQualityScorecardUnderwritingApi = new BrokerQualityScorecardUnderwritingApi(
  httpUnderwritingApi,
);

export const brokerQualityScorecardLoansApi = new BrokerQualityScorecardLoansApi(httpLoansApi);

// DEV-3781 internal AE broker-quality coaching page — the AE reads the brokers
// they own (Accounts), then each broker's scorecard via the same two gateways as
// the broker-facing zone, but on the internal AE path that carries an explicit
// subCompanyId. All endpoints 404 when the backend feature toggle is off.
export const aeBrokersApi = new AeBrokersApi(httpAccountsApi);

export const aeBrokerQualityScorecardApi = new AeBrokerQualityScorecardApi(
  httpUnderwritingApi,
  httpLoansApi,
);

export const brokerAnnouncementsApi = new BrokerAnnouncementsApi(httpLoansApi);

export const brokerAnnouncementsAdminApi = new BrokerAnnouncementsAdminApi(httpLoansApi);

export const brokerClientProtectionApi = new BrokerClientProtectionApi(httpAccountsApi);

export const brokerClientProtectionAdminApi = new BrokerClientProtectionAdminApi(httpAccountsApi);

export const lockExpiryApi = new LockExpiryApi(httpLoansApi);

export const loanActivityApi = new LoanActivityApi(httpLoansApi);

export const companyVolumeApi = new CompanyVolumeApi(httpLoansApi);

export const marketRatesApi = new MarketRatesApi(httpPricingApi);

export const brokerCompPlanApi = new BrokerCompPlanApi(httpAccountsApi);

export const subCompanyOwnerStatusApi = new SubCompanyOwnerStatusApi(httpAccountsApi);

export const tpoRecapEarningsApi = new TpoRecapEarningsApi(httpSkynetApi);

export const companyClaimRestrictionsApi = new CompanyClaimRestrictionsApi(httpAccountsApi);

export const companyRoleRestrictionsApi = new CompanyRoleRestrictionsApi(httpAccountsApi);

export const companyTemplateApi = new CompanyTemplateApi(httpSkynetApi);

export const businessDaysManagementApi = new BusinessDaysApi(httpAccountsApi);

export const companyAudioRecordingApi = new CompanyAudioRecordingApi(httpSkynetApi);

export const companyDomainApi = new CompanyDomainApi(httpAccountsApi);

export const companyEmailDomainApi = new CompanyEmailDomainApi(httpAccountsApi);

export const companyLicenseStateApi = new CompanyLicenseStateApi(httpAccountsApi);

export const companySsoInfoApi = new CompanySsoInfoApi(httpSkynetApi);

export const conditionApi = new ConditionApi(httpUnderwritingApi);

export const conditionCategoryApi = new ConditionCategoryApi(httpUnderwritingApi);

export const conditionConditionSetApi = new ConditionConditionSetApi(httpUnderwritingApi);

export const conditionPriorToTypeDefinitionApi = new ConditionPriorToTypeDefinitionApi(
  httpUnderwritingApi,
);

export const conditionProgramLoanTypeApi = new ConditionProgramLoanTypeApi(httpUnderwritingApi);

export const conditionSetApi = new ConditionSetApi(httpUnderwritingApi);

export const contactsApi = new ContactsApi(httpSkynetApi);

export const contactTaskApi = new ContactTaskApi(httpLoansApi);

export const csvMappingApi = new CsvMappingApi(httpSkynetApi);

export const csvMappingDefinitionApi = new CsvMappingDefinitionApi(httpSkynetApi);

export const cubeIntegrationApi = new CubeIntegrationApi(httpSkynetApi);

export const customActionApi = new CustomActionApi(httpUnderwritingApi);

export const customAdjustmentTypeApi = new CustomAdjustmentTypeApi(httpPricingApi);

export const customRuleApi = new CustomRuleApi(httpUnderwritingApi);

export const customRuleCategoryApi = new CustomRuleCategoryApi(httpUnderwritingApi);

export const customRuleGroupApi = new CustomRuleGroupApi(httpUnderwritingApi);

export const customQuestionsApi = new CustomQuestionsApi(httpSkynetApi);

export const dealApi = new DealApi(httpSkynetApi);

export const dealerApi = new DealerApi(httpSkynetApi);

export const documentTypeFieldsMappingApi = new DocumentTypeFieldsMappingApi(httpSkynetApi);

export const denialReasonsApi = new DenialReasonsApi(httpSkynetApi);

export const devicesApi = new DevicesApi(httpAccountsApi);

export const exceptionSubCategoriesApi = new ExceptionSubCategoriesApi(httpSkynetApi);

export const documentApi = new DocumentApi(httpSkynetApi);

export const documentBundleApi = new DocumentBundleApi(httpSkynetApi);

export const documentExtractionSessionsApi = new DocumentExtractionSessionsApi(httpDocumentsApi);

export const documentFieldTypeApi = new DocumentFieldTypeApi(httpDocumentsApi);

export const documentTypeExtractionFieldApi = new DocumentTypeExtractionFieldApi(httpDocumentsApi);

export const documentTypeCalculationFieldApi = new DocumentTypeCalculationFieldApi(httpSkynetApi);

export const documentTypeExpressionDefinitionApi = new DocumentTypeExpressionDefinitionApi(
  httpSkynetApi,
);

export const eligibilityCriteriaApi = new EligibilityCriteriaApi(httpPricingApi);
export const escrowCriteriaApi = new EscrowCriteriaApi(httpPricingApi);

export const emailNotificationSkynetApi = new EmailNotificationApi(httpSkynetApi);
export const emailNotificationsNotificationsApi = new NotificationsApi(httpNotificationsApi);

export const pushNotificationsApi = new PushNotificationsApi(httpNotificationsApi);

export const emailSignatureApi = new EmailSignatureApi(httpNotificationsApi);

export const emailSignaturePreviewApi = new EmailSignaturePreviewApi(httpSkynetApi);

export const emailSnippetsApi = new EmailSnippetsApi(httpSkynetApi);

export const emailTemplateApi = new EmailTemplateApi(httpNotificationsApi);

export const emailTemplateCategoryApi = new EmailTemplateCategoryApi(httpSkynetApi);

export const emailTemplateProcessingApi = new EmailTemplateProcessingApi(httpSkynetApi);

export const entityOrderApi = new EntityOrderApi(httpUnderwritingApi);

export const expressionDefinitionApi = new ExpressionDefinitionApi(httpSkynetApi);
export const expressionDefinitionApiV2 = new ExpressionDefinitionApiV2(httpPricingApi);

export const featureTogglesApi = new FeatureTogglesApi(httpSkynetApi);

export const feeProviderPricingApi = new FeeProviderPricingApi(httpPricingApi);

export const feeProviderCategoryApi = new FeeProviderCategoryApi(httpSkynetApi);

export const feeProviderCategoryPricingApi = new FeeProviderCategoryPricingApi(httpPricingApi);

export const feeTypePricingApi = new FeeTypePricingApi(httpPricingApi);

export const feeTypeMismoApi = new FeeTypeMismoApi(httpPricingApi);

export const formApi = new FormApi(httpSkynetApi);

export const formsApi = new FormsApi(httpFormsApi);

export const formsExpressionDefinitionApi = new FormsExpressionDefinitionApi(httpFormsApi);

export const formBundleApi = new FormBundleApi(httpSkynetApi);

export const formBundleCriteriaApi = new FormBundleCriteriaApi(httpApplyApi);

export const formBundlesApi = new FormBundlesApi(httpFormsApi);

export const formBundleTestingToolApi = new FormBundleTestingToolApi(httpSkynetApi);

export const formBundleSignatureRequestApi = new FormBundleSignatureRequestApi(httpSkynetApi);

export const formsSignatureRequestApi = new FormBundleSignatureRequestApi(httpFormsApi);

export const formsTestingToolApi = new FormsTestingToolApi(httpFormsApi);

export const formDeliveryRequestApi = new FormDeliveryRequestApi(httpFormsApi);

export const fundingInformationApi = new FundingInformationApi(httpSkynetApi);

export const postClosingApi = new PostClosingApi(httpSkynetApi);

export const headerViewApi = new HeaderViewApi(httpSkynetApi);

export const httpRequestLogsApi = new HttpRequestLogsApi(httpPricingApi);

export const hudApi = new HudApi(httpSkynetApi);

export const incomeCalculatorApi = new IncomeCalculatorApi(httpUnderwritingApi);

export const indexTypeApi = new IndexTypeApi(httpPricingApi);

export const investorApi = new InvestorApi(httpSkynetApi);

export const leadSourceApi = new LeadSourceApi(httpSkynetApi);

export const llpaCapCriteriaApi = new LlpaCapCriteriaApi(httpPricingApi);

export const llpaTypeApi = new LlpaTypeApi(httpPricingApi);

export const loanApplicationsApi = new LoanApplicationsApi(httpLoansApi);

export const loanAppraisalSurchargesApi = new LoanAppraisalSurchargesApi(httpLoansApi);

export const loanApplicationsProgressApi = new LoanApplicationsProgressApi(httpLoansApi);

export const loanApplicationBorrowersApi = new LoanApplicationBorrowersApi(httpLoansApi);

export const loanApplicationNonBorrowersApi = new LoanApplicationNonBorrowersApi(httpLoansApi);

export const loanApplicationTagsApi = new LoanApplicationTagsApi(httpLoansApi);

export const loanApplicationRoleAssignmentsApi = new LoanApplicationRoleAssignmentsApi(
  httpLoansApi,
);

export const loanApplicationTagsAssignmentsApi = new LoanApplicationTagsAssignmentsApi(
  httpLoansApi,
);

export const loanActionApi = new LoanActionApi(httpSkynetApi);

export const loanActionApiV2 = new LoanActionApiV2(httpLoanProcessingApi);

export const loanApi = new LoanApi(httpSkynetApi);

export const loanConditionApiV2 = new LoanConditionApiV2(httpUnderwritingApi);

export const loanConsentsApi = new LoanConsentsApi(httpSkynetApi);

export const loanDenialReasonsApi = new LoanDenialReasonsApi(httpSkynetApi);

export const loanEditorCustomFormsApi = new LoanEditorCustomFormsApi(httpLoansApi);

export const loanExceptionsApi = new LoanExceptionsApi(httpSkynetApi);
// ConstructionController lives in the loans service (Interfirst.Skynet.Loans.API), like
// CustomFields/LoanApplications/LoanPipelines — must use httpLoansApi, not httpSkynetApi.
export const constructionApi = new ConstructionApi(httpLoansApi);

export const loanKeyDatesApi = new LoanKeyDatesApi(httpSkynetApi);

export const loanLockDeskSettingsApi = new LoanLockDeskSettingsApi(httpSkynetApi);

export const loanOfficersManagementApi = new LoanOfficersManagementApi(httpSkynetApi);

export const loanOptionApi = new LoanOptionApi(httpPricingApi);

export const loanPipelinesApi = new LoanPipelinesApi(httpLoansApi);

export const loanProcessingDefinitionsApi = new LoanProcessingDefinitionsApi(httpLoanProcessingApi);

export const loanRoleApi = new LoanRoleApi(httpSkynetApi);

export const loanRolesApi = new LoanRolesApi(httpLoansApi);

export const loanRoleRelationshipsApi = new LoanRoleRelationshipsApi(httpLoansApi);

export const loanSellerAdjustmentsApi = new LoanSellerAdjustmentsApi(httpSkynetApi);

export const localizationLanguageApi = new LocalizationLanguageApi(httpApplyApi);

export const localizationStringApi = new LocalizationStringApi(httpApplyApi);

export const locationsApi = new LocationsApi(httpSkynetApi);

export const markToMarketSettingApi = new MarkToMarketSettingApi(httpSkynetApi);

export const lodeStarFeeTypeApi = new LodeStarFeeTypeApi(httpSkynetApi);

export const loanLodeStarQuestionsApi = new LoanLodeStarQuestionsApi(httpSkynetApi);

export const lodeStarFeeTypePricingApi = new LodeStarFeeTypePricingApi(httpPricingApi);

export const miCoverageApi = new MiCoveragePercentageCriteriaApi(httpPricingApi);

export const milestoneDefinitionsApi = new MilestoneDefinitionsApi(httpLoansApi);

export const miRulesCriteriaApi = new MIRulesCriteriaApi(httpPricingApi);

export const rateLockTermsCriteriaApi = new RateLockTermsCriteriaApi(httpPricingApi);

export const pushNotificationsDispatchApi = new PushNotificationsDispatchApi(httpNotificationsApi);

export const msrValueApi = new MsrValueApi(httpSkynetApi);

export const phoneNumberApi = new PhoneNumberApi(httpSkynetApi);

export const pricingWorkbenchApi = new PricingWorkbenchApi(httpSkynetApi);

export const programApi = new ProgramApi(httpPricingApi);

export const buyDownsApi = new BuyDownsApi(httpPricingApi);

export const realtorsApi = new RealtorsApi(httpSkynetApi);

export const rolesManagementApi = new RolesManagementApi(httpAccountsApi);

export const sellerAdjustmentTypeApi = new SellerAdjustmentTypeApi(httpPricingApi);

// F6 search synonyms (DEV-4214): SearchSynonymsController lives in Interfirst.Skynet.Loans.API,
// so this must use httpLoansApi, not httpUnderwritingApi like the adjacent conditionCategoryApi.
export const searchSynonymApi = new SearchSynonymApi(httpLoansApi);

export const vestingTypeApi = new VestingTypeApi(httpSkynetApi);

export const postClosingOptionListApis = _.mapValues(
  POST_CLOSING_OPTION_ROUTE_BASE,
  routeBase => new PostClosingOptionListApi(httpSkynetApi, routeBase),
);

export const servicingCompaniesApi = new ServicingCompaniesApi(httpSkynetApi);

export const ssoApi = new SsoApi(httpSkynetApi);

export const systemPropertiesApi = new SystemPropertiesApi(httpSkynetApi);

export const tagApi = new TagApi(httpSkynetApi);

export const taskApi = new TaskApi(httpLoansApi);

export const subCompanyTaskApi = new SubCompanyTaskApi(httpLoansApi);

export const subCompanyLoanCountApi = new SubCompanyLoanCountApi(httpLoansApi);

export const subCompanyCeilingDerivationApi = new SubCompanyCeilingDerivationApi(httpSkynetApi);

export const taskCategoryApi = new TaskCategoryApi(httpLoansApi);

export const turnTimeDefinitionApi = new TurnTimeDefinitionApi(httpLoansApi);

export const pipelineStatusApi = new PipelineStatusApi(httpLoansApi);

export const commandCenterLoansApi = new CommandCenterLoansApi(httpLoansApi);

export const commandCenterPricingApi = new CommandCenterPricingApi(httpPricingApi);

export const commandCenterUnderwritingApi = new CommandCenterUnderwritingApi(httpUnderwritingApi);

export const taskCategoryExclusionApi = new TaskCategoryExclusionApi(httpLoansApi);

export const taskSlaGroupApi = new TaskSlaGroupApi(httpLoansApi);

export const taskTypeApi = new TaskTypeApi(httpLoansApi);

export const taskTypeDynamicFieldApi = new TaskTypeDynamicFieldApi(httpLoansApi);

export const taskTypeExclusionApi = new TaskTypeExclusionApi(httpLoansApi);

export const telephonyApi = new TelephonyApi(httpSkynetApi, httpTelephonyApi);

export const telnyxPhoneNumberApi = new TelnyxPhoneNumberApi(httpTelephonyApi);

export const texmlApplicationsApi = new TexmlApplicationsApi(httpTelephonyApi);

export const underwriterApi = new UnderwriterApi(httpUnderwritingApi);

export const underwritingApi = new UnderwritingApi(httpSkynetApi);

export const closingApi = new ClosingApi(httpSkynetApi);

export const closingInfoApi = new ClosingInfoApi(httpSkynetApi);

export const closingPortalApi = new ClosingPortalApi(httpLoansApi);
export const loanFeeRecommendationsApi = new LoanFeeRecommendationsApi(httpLoansApi);

export const underwritingReportApi = new UnderwritingReportApi(httpSkynetApi);

export const underwritingExpressionDefinitionApi = new UnderwritingExpressionDefinitionApi(
  httpUnderwritingApi,
);

export const underwritingSettingsApi = new UnderwritingSettingsApi(httpSkynetApi);

export const underwritingDocExpirationSettingsApi = new UnderwritingDocExpirationSettingsApi(
  httpSkynetApi,
);

export const userObsoleteApi = new UserApi(httpSkynetApi);

export const userAudioRecordingApi = new UserAudioRecordingApi(httpSkynetApi);

export const userLicenseStateApi = new UserLicenseStateApi(httpAccountsApi);

export const userPropertiesManagementApi = new UserPropertiesManagementApi(httpAccountsApi);

export const usersManagementApi = new UsersManagementApi(httpAccountsApi);

export const userLeadAssignmentRule = new UserLeadAssignmentRule(httpSkynetApi);

export const optimizationStrategyApi = new OptimizationStrategyApi(httpLoansApi);

export const warehouseBankApi = new WarehouseBankApi(httpSkynetApi);

export const warehouseBankLineApi = new WarehouseBankLineApi(httpLoansApi);

export const warehouseLineAllocationApi = new WarehouseLineAllocationApi(httpLoansApi);

export const slaGroupApi = new SlaGroupApi(httpLoansApi);

export const documentsApi = new DocumentsApi(httpDocumentsApi);

export const documentTypesApi = new DocumentTypesApi(httpDocumentsApi);

export const documentTypeAliasesApi = new DocumentTypeAliasesApi(httpDocumentsApi);

export const documentWorksheetApi = new DocumentWorksheetApi(httpDocumentsApi);

export const documentCategoriesApi = new DocumentCategoriesApi(httpDocumentsApi);

export const documentBundlesApi = new DocumentBundlesApi(httpDocumentsApi);

export const documentAuditEventsApi = new DocumentAuditEventsApi(httpDocumentsApi);

export const closingDocumentsApi = new ClosingDocumentsApi(httpAusApi);

export const appKeyApi = new AppKeyApi(httpAccountsApi);

export const pricingConfigurationApi = new PricingConfigurationApi(httpPricingApi);

export const contactsPresentationApi = new ContactsPresentationApi(httpSkynetApi);

export const ausApi = new AusApi(httpSkynetApi);

export const ausCredentialValidationApi = new AusCredentialValidationApi(httpAusApi);

export const ausFindingsApi = new AusFindingsApi(httpAusApi);

export const ausSubmitApi = new AusSubmitApi(httpAusApi);

export const investorProductPlanIdentifiersApi = new InvestorProductPlanIdentifiersApi(
  httpPricingApi,
);

export const financialInfoApi = new FinancialInfoApi(httpLoansApi);

export const mortgageReportsApi = new MortgageReportsApi(httpAusApi);

export const dataVerifyApi = new DataVerifyApi(httpAusApi);

export const importMismoApi = new ImportMismoApi(httpAusApi);

export const companyFormFieldsApi = new CompanyFormFieldsApi(httpAccountsApi);

export const companyLoanNumberApi = new CompanyLoanNumberApi(httpSkynetApi);

export const subCompaniesApi = new SubCompaniesApi(httpAccountsApi);

export const subCompanyAgencyApprovalsApi = new SubCompanyAgencyApprovalsApi(httpAccountsApi);

export const subCompanyAssignedAeApi = new SubCompanyAssignedAeApi(httpAccountsApi);

export const subCompanyChannelsApi = new SubCompanyChannelsApi(httpAccountsApi);

export const subCompanyChecklistsApi = new SubCompanyChecklistsApi(httpAccountsApi);

export const subCompanyChecklistsAuthoringApi = new SubCompanyChecklistsAuthoringApi(
  httpAccountsApi,
);

export const subCompanyCompensationPlanApi = new SubCompanyCompensationPlanApi(httpAccountsApi);

export const subCompanyCreditProviderApi = new SubCompanyCreditProviderApi(httpSkynetApi);

export const companyCompensationComplianceApi = new CompanyCompensationComplianceApi(
  httpAccountsApi,
);

export const subCompanyLicenseStateApi = new SubCompanyLicenseStateApi(httpAccountsApi);

export const nmlsLicenseApi = new NmlsLicenseApi(httpApplyApi);

export const uiProgramSettingsApi = new UiProgramSettingsApi(httpPricingApi);

export const housingFinanceAgenciesApi = new HousingFinanceAgenciesApi(httpLoansApi);

export const documentExpirationDatesApi = new DocumentExpirationDatesApi(httpSkynetApi);

export const analyticsApi = new AnalyticsApi(httpSkynetApi);

export const lienPriorityApi = new LienPriorityApi(httpLoansApi);

export const contactTypesApi = new ContactTypesApi(httpSkynetApi);

export const creditCompaniesApi = new CreditCompaniesApi(httpSkynetApi);

export const loanContactsApi = new LoanContactsApi(httpLoansApi);

export const applicationContactsApi = new ApplicationContactsApi(httpSkynetApi);

export const aiPersonasApi = new AiPersonasApi(httpAiApi);

export const aiProcessesApi = new AiProcessesApi(httpAiApi);

export const aiProcessStepsApi = new AiProcessStepsApi(httpAiApi);

export const knowledgeItemsApi = new KnowledgeItemsApi(httpAiApi);

export const knowledgeItemExclusionApi = new KnowledgeItemExclusionApi(httpAiApi);

export const aiUsageMetricsApi = new AiUsageMetricsApi(httpAiApi);

export const aiProcessStepBlobsApi = new AiProcessStepBlobsApi(httpAiApi);

export const aiProcessRunsApi = new AiProcessRunsApi(httpAiApi);

export const aiStatsApi = new AiStatsApi(httpAiApi);

export const aiChatConfigurationsApi = new AiChatConfigurationsApi(httpAiApi);

export const aiAgentsApi = new AiAgentsApi(httpAiApi);

export const aiSkillsApi = new AiSkillsApi(httpAiApi);

export const aiCompositionApi = new AiCompositionApi(httpAiApi);

export const aiConfigApi = new AiConfigApi(httpAiApi);
export const aiProcessVersionsApi = new AiProcessVersionsApi(httpAiApi);

export const aiStepChecksApi = new AiStepChecksApi(httpAiApi);

export const aiRulesApi = new AiRulesApi(httpAiApi);

export const aiModelsApi = new AiModelsApi(httpAiApi);

export const aiModelAssignmentsApi = new AiModelAssignmentsApi(httpAiApi);

export const guidelinesApi = new GuidelinesApi(httpAiApi);

export const guidelineSourceExclusionApi = new GuidelineSourceExclusionApi(httpAiApi);

export const servicingApi = new ServicingApi(httpLoansApi);

export const specifiedPoolApi = new SpecifiedPoolApi(httpLoansApi);

export const tradeApi = new TradeApi(httpLoansApi);

export const posConfigurationApi = new PosConfigurationApi(httpApplyApi);

export const tpoSignupConfigurationApi = new TpoSignupConfigurationApi(httpApplyApi);
export const tpoDenialConfigurationApi = new TpoDenialConfigurationApi(httpApplyApi);

export const tpoCertificationsApi = new TpoCertificationsApi(httpApplyApi);

export const tpoCertificationApi = new TpoCertificationApi(httpApplyApi);

export const advisorPortalConfigurationApi = new AdvisorPortalConfigurationApi(httpApplyApi);

export const wireInstructionConfirmationApi = new WireInstructionConfirmationApi(httpLoansApi);

export const whitelistApi = new WhitelistApi(httpAccountsApi);

export const companyIpWhitelistApi = new CompanyIpWhitelistApi(httpAccountsApi);

export const companyPropertiesApi = new CompanyPropertiesApi(httpSkynetApi);

export const campaignApi = new CampaignApi(httpCrmApi);

export const crmContactApi = new CrmContactApi(httpCrmApi);
export const leadAssignmentRulesApi = new LeadAssignmentRulesApi(httpCrmApi, httpLoansApi);
export const leadWorkspaceApi = new LeadWorkspaceApi(httpCrmApi, httpSkynetApi, httpLoansApi);

export const contactCustomFieldDefinitionsApi = new ContactCustomFieldDefinitionsApi(httpCrmApi);

export const crmPipelineApi = new CrmPipelineApi(httpCrmApi);

export const subCompanyPipelineApi = new SubCompanyPipelineApi(httpLoanProcessingApi);

export const webhooksApi = new WebhooksApi(httpLoanProcessingApi);

// DEV-4697 broker-side pipeline-access matrix (exposed pipelines x seeded sub-company roles).
// Composed from the SkynetAPI exposed-pipelines BFF (rows) + the Loans securityGroups contract
// (cells + writes); scoped server-side from the authenticated broker user.
export const subCompanyPipelineAccessApi = new SubCompanyPipelineAccessApi(
  httpSkynetApi,
  httpLoansApi,
);

// DEV-4697 lender-side save-time validation of a config's exposed pipelines (SkynetAPI BFF).
export const tpoExposedPipelinesValidationApi = new TpoExposedPipelinesValidationApi(httpSkynetApi);

export const crmTagApi = new CrmTagApi(httpCrmApi);

export const loanApplicationCommonInfoApi = new LoanApplicationCommonInfoApi(httpLoansApi);

export const halcyonFormCatalogApi = new HalcyonFormCatalogApi(httpSkynetApi);

export const propertyEnrichmentApi = new PropertyEnrichmentApi(httpSkynetApi);

export const integrationStudioApi = new IntegrationStudioApi(
  httpIntegrationsApi,
  httpLoanProcessingApi,
);
export const bankrateLeadProviderApi = new BankrateLeadProviderApi(httpIntegrationsApi);
export const shapeLeadProviderApi = new ShapeLeadProviderApi(httpIntegrationsApi);
export const legacySftpConnectorApi = new LegacySftpConnectorApi(httpIntegrationsApi);
export const loanImportsApi = new LoanImportsApi(httpIntegrationsApi);
export const servicelinkFloodApi = new ServicelinkFloodApi(httpIntegrationsApi);
export const snapdocsClosingApi = new SnapdocsClosingApi(httpIntegrationsApi);
export const snapdocsSubscriptionsApi = new SnapdocsSubscriptionsApi(httpIntegrationsApi);
export const mobileAppReleaseApi = new MobileAppReleaseApi(httpAccountsApi);
